import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { stripLang } from "@/lib/routes";

/**
 * Scrolls to top on route change, EXCEPT when only the language prefix changed
 * (language switch must keep the reading position) and except for hash links.
 */
export default function ScrollToTop() {
  const location = useLocation();
  const prevRef = useRef(null);

  useEffect(() => {
    const current = stripLang(location.pathname);
    const prev = prevRef.current;
    prevRef.current = current;

    if (prev === null) return; // first paint
    if (location.hash) return; // anchor navigation
    if (prev === current) return; // language switch only

    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
  }, [location.pathname, location.hash]);

  return null;
}
